import { render, staticRenderFns } from "./DialogBicEditIndex.vue?vue&type=template&id=6d30a0ff&scoped=true&lang=html&"
import script from "./DialogBicEditIndex.vue?vue&type=script&lang=js&"
export * from "./DialogBicEditIndex.vue?vue&type=script&lang=js&"
import style0 from "./DialogBicEditIndex.vue?vue&type=style&index=0&id=6d30a0ff&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d30a0ff",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBottomNavigation } from 'vuetify/lib/components/VBottomNavigation';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBottomNavigation,VBtn,VCardTitle,VCol,VDialog,VIcon,VRow,VSpacer})
